export async function clearLocalStorage() {
  if (getItem("accountLoginUser")) {
    await window.localStorage.removeItem("accountLoginUser");
  }
  if (getItem("accountPeriod")) {
    await window.localStorage.removeItem("accountPeriod");
  }
  if (getItem("accountCompany")) {
    await window.localStorage.removeItem("accountCompany");
  }
  if (getItem("accountInvoiceMsg")) {
    await window.localStorage.removeItem("accountInvoiceMsg");
  }
  // await window.localStorage.clear()
}

export function getItem(str) {
  try {
    return window.localStorage.getItem(str) &&
      window.localStorage.getItem(str) !== "undefined"
      ? JSON.parse(window.localStorage.getItem(str))
      : null;
  } catch (error) {
    return window.localStorage.getItem(str) &&
      window.localStorage.getItem(str) !== "undefined"
      ? window.localStorage.getItem(str)
      : null;
  }
}

export async function setItem(key, value) {
  await window.localStorage.setItem(key, JSON.stringify(value));
}

export async function removeItem(key) {
  await window.localStorage.removeItem(key);
}

export function getToken() {
  return getItem("accountLoginUser") ? getItem("accountLoginUser").token : null;
}

export function getAgent() {
  return getItem("accountLoginUser") ? getItem("accountLoginUser").agent : null;
}



// WEBPACK FOOTER //
// ./src/utils/storage.js